import { useTranslation } from "react-i18next";
import { useStructureContext } from "../../../../context/StructureContext";
import { headerCommItems, headerCommPay } from "../../../../data/admin";
import { stdObject } from "../../../../data/types/stdObject";
import StdTable from "../StdTable";
import { useEffect } from "react";
import { useMainContext } from "../../../../context/MainContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { dataFiltered } from "./dataFiltered";

export default function CommReport() {
  const {
    type,
    searchValues,
    setSearchValues,
    section,
    printArea,
    findServiceData,
  } = useStructureContext();
  const { customUpdate } = useMainContext();
  const { t } = useTranslation();
  const userAccess: stdObject = useSelector(
    (state: RootState) => state.data.userAccess,
  );

  useEffect(() => {
    if (
      "mainInfo" in customUpdate.current &&
      customUpdate.current.mainInfo === "COMM"
    ) {
      findServiceData();
      customUpdate.current = {};
    }
  }, [customUpdate.current]);

  const selectComm = (v: stdObject, e: string) => {
    let tempData = searchValues;
    const commIndex = tempData[section.id].results.items[e].list.findIndex(
      (o: stdObject) =>
        [
          "AGECOY",
          "ARTCOY",
          "CANCOY",
          "CODCOY",
          "COMMCOY",
          "DOCCOY",
          "GRUCOY",
          "LINCOY",
          "PAGCOY",
          "BASCOY",
          "PRECOY",
          "PROCOY",
          "SERCOY",
        ].every((w: string) => o[w] === v[w]),
    );
    if (commIndex > -1) {
      tempData[section.id].results.items[e].list[commIndex].ACTIVE = !v.ACTIVE;
      setSearchValues({ ...tempData });
    }
  };

  const tableItemsFiltered = (e: string, index: number, lastOne: boolean) => {
    const totalData = dataFiltered(e, searchValues[section.id]);
    const userId = searchValues[section.id].PERICO.value;
    return (
      totalData.length > 0 &&
      (userId === "" || (userId > 0 && Number(userId) === Number(e))) && (
        <StdTable
          type={type}
          key={index}
          mainHeader={searchValues[section.id].results.items[e].name}
          style={{ width: "100%", marginBottom: lastOne ? 0 : 20 }}
          header={
            searchValues[section.id].ESTD2ICO.value === "0" &&
            userAccess.D.D2 === 3
              ? [
                  {
                    code: "ACTIVE",
                    label: "",
                    type: "checkbox",
                    onClick: (v: stdObject) => selectComm(v, e),
                  },
                  ...headerCommItems,
                ]
              : headerCommItems
          }
          data={totalData}
          totals={headerCommItems.reduce((acc: stdObject, curr: stdObject) => {
            if (["TOTCOY", "COMMTOTCOY"].includes(curr.code)) {
              acc[curr.code] = totalData.reduce(
                (ac: number, cu: stdObject) => (ac += cu[curr.code]),
                0,
              );
            }
            if (
              curr.code === "PAGCOY" &&
              searchValues[section.id].ESTD2ICO.value === "0" &&
              userAccess.D.D2 === 3
            ) {
              acc[curr.code] = {
                label: t("p.approve"),
                type: "button",
                values: totalData,
                style: { float: "right" },
              };
            }
            return acc;
          }, {})}
        />
      )
    );
  };

  const tableCommFiltered = (e: string, index: number, lastOne: boolean) => {
    const totalData = searchValues[section.id].results.commissions[e].list;
    const userId = searchValues[section.id].PERICO.value;
    return (
      totalData.length > 0 &&
      (userId === "" || Number(userId) === Number(e)) && (
        <StdTable
          type={type}
          key={index}
          align="center"
          mainHeader={searchValues[section.id].results.commissions[e].name}
          style={{ marginBottom: lastOne ? 0 : 20 }}
          header={
            userAccess.D.D2 === 3
              ? headerCommPay
              : headerCommPay.filter(
                  (e: stdObject) =>
                    !["BUTTONCOYP", "BUTTONDELCOYP"].includes(e.code),
                )
          }
          data={totalData}
        />
      )
    );
  };

  return "results" in searchValues[section.id] ? (
    <div ref={printArea} className="listBox">
      {searchValues[section.id].ESTD2ICO.value === "2"
        ? Object.keys(searchValues[section.id].results.commissions).map(
            (e: string, index: number) =>
              tableCommFiltered(
                e,
                index,
                index >=
                  Object.keys(searchValues[section.id].results.commissions)
                    .length -
                    1,
              ),
          )
        : Object.keys(searchValues[section.id].results.items).map(
            (e: string, index: number) =>
              tableItemsFiltered(
                e,
                index,
                index >=
                  Object.keys(searchValues[section.id].results.items).length -
                    1,
              ),
          )}
    </div>
  ) : (
    <></>
  );
}
